import { getRetryDelayErrorMessage as errorMessage } from "./constants";

const getRetryDelayError = retryDelay => {
  if (!["function", "undefined"].includes(typeof retryDelay)) {
    return errorMessage;
  }
};

export default getRetryDelayError;
